import React from 'react';
import {View, Button, Text} from 'react-native';
import useLocalNotification from '../hooks/localNotificationHandler';
import {navigate} from "../hooks/navigationService";
import styled from "styled-components/native";

import ClockImage from '../../assets/clock.png'

import {
    WorkoutsParent,
    WorkoutContainerText,
    WorkoutTextHeader,
    CerebrocoreCommonTextComponent,
    WorkoutContainerHeaderThree,
    WorkoutCommonButton,
    WorkoutCommonButtonTwo,
    WorkoutTextSubHeader
} from '../styles/common-styles';
import {useSelector} from "react-redux";
import Bugsnag from "@bugsnag/expo";
import {navigation} from "../hooks/navigationService";

function Snooze() {
    const {scheduleNotification} = useLocalNotification();
    const {
        current_workout_activity,
        current_workout,
        workout_loading_msg,
        daily_workout_completed,
    } = useSelector((state) => state.cbcWorkout);
    let isWarmUpActivity = false;
    let hasActivityChoices = false;

    if (current_workout_activity) {
        if (current_workout && current_workout_activity.id == 27) {
            isWarmUpActivity = true;
        }

        if (current_workout_activity.activity_choices) {
            hasActivityChoices = true;
        }
    }
    const handleReminder = async (minutes) => {
        const title = "Workout Reminder";
        const body = `It's time for your workout!`;
        await scheduleNotification(title, body, {seconds: minutes * 60});
        navigate('dashboard')
    };

    const handleReminderTest = async () => {
        const title = "Workout Reminder";
        const body = `It's time for your workout!`;
        await scheduleNotification(title, body, {seconds: 30});
        navigate('dashboard')
    };

    return (
        <SnoozeParent contentContainerStyle={{flexGrow: 1, justifyContent: 'center', alignItems: 'center'}}>
            <SnoozeBGImage
                source={{uri: 'https://dev.cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/media/backgrounds/Cerebrocore_workout-bkg-weight.png'}}
            />

            {/*<NotificationManagerHeaderParent>*/}
            {/*    <NotificationManagerHeaderClockImg*/}
            {/*        source={ClockImage}*/}
            {/*    />*/}
            {/*    <NotificationManagerHeaderText>REMINDERS</NotificationManagerHeaderText>*/}
            {/*</NotificationManagerHeaderParent>*/}


            <SnoozeHeaderText>Are you ready to begin?</SnoozeHeaderText>
            <SnoozeHeaderButtonParent>
                <SnoozeHeaderButton onPress={() => {
                    setTimeout(function () {
                        if (hasActivityChoices) {
                            const activityObj = [
                                {
                                    activity_list: current_workout_activity.activity_choices,
                                    category_name: 'Free choice',
                                    category_text: 'Please select an activity from below.',
                                },
                            ]
                            navigate('activitylist', {
                                activityObj,
                                current_workout,
                                navigation,
                                isWorkout: true
                            });
                        } else if (isWarmUpActivity) {
                            navigate('workoutintro');
                        } else {

                            try {
                                Bugsnag.notify('User navigating to GameView');
                            } catch (e) {
                                //dispatch(PivotLogging({moduleName: 'TodaysWorkout' , consoleLog: `Unable to notify bugsnag: ${e}`}));
                            }

                            Bugsnag.leaveBreadcrumb('Navigating to GameView');
                            //dispatch(PivotLogging({moduleName: 'TodaysWorkout' , consoleLog: 'navigating to Gameview'}));
                            navigate('gameview', {
                                current_workout_activity,
                                current_workout,
                            });
                        }
                    }, 500);
                }}>
                    <SnoozeHeaderButtonText>START WORKOUT</SnoozeHeaderButtonText>
                </SnoozeHeaderButton>
            </SnoozeHeaderButtonParent>
            <SnoozeHeaderSkipButton onPress={() => navigate('dashboard')}>
                SKIP THIS WORKOUT
            </SnoozeHeaderSkipButton>

            <SnoozeHeaderSubText>NOT NOW, REMIND ME IN:</SnoozeHeaderSubText>
            <SnoozeCommonButtonParent>
                <SnoozeCommonButton onPress={() => handleReminder(5)}>
                    <SnoozeCommonButtonText>
                        5 MINUTES
                    </SnoozeCommonButtonText>
                </SnoozeCommonButton>

                <SnoozeCommonButton onPress={() => handleReminder(15)}>
                    <SnoozeCommonButtonText>
                        15 MINUTES
                    </SnoozeCommonButtonText>
                </SnoozeCommonButton>

                <SnoozeCommonButton onPress={() => handleReminder(30)}>
                    <SnoozeCommonButtonText>
                        30 MINUTES
                    </SnoozeCommonButtonText>
                </SnoozeCommonButton>

                <SnoozeCommonButton onPress={() => handleReminder(60)}>
                    <SnoozeCommonButtonText>
                        1 HOUR
                    </SnoozeCommonButtonText>
                </SnoozeCommonButton>

                <SnoozeCommonButton onPress={() => handleReminder(120)}>
                    <SnoozeCommonButtonText>
                        2 HOURS
                    </SnoozeCommonButtonText>
                </SnoozeCommonButton>
            </SnoozeCommonButtonParent>
        </SnoozeParent>
    );
}

const SnoozeParent = styled.ScrollView`
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 30px;
  background-color: #282F63;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const SnoozeBGImage = styled.Image`
  width: 100%;
  height: 400px;
  position: absolute;
  top: -65px;
  left: 25px;
`;

const NotificationManagerHeaderParent = styled.View`
  margin-bottom: 40px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
`;

const NotificationManagerHeaderClockImg = styled.Image`
  width: 50px;
  height: 50px;
  margin-right: 10px;
`;

const NotificationManagerHeaderText = styled.Text`
  color: #C04C97;
  font-family: 'Montserrat-EB';
  font-size: 19px;
  margin-top: 5px;
`;

const SnoozeHeaderText = styled.Text`
  font-family: 'Montserrat-EB';
  font-size: 18px;
  color: white;
`;

const SnoozeHeaderButtonParent = styled.View`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const SnoozeHeaderButton = styled(WorkoutCommonButton)`
  height: 65px;
  width: 300px;
  padding-left: 0;
  padding-right: 0;
`

const SnoozeHeaderButtonText = styled.Text`
  font-family: 'Montserrat-SB';
  font-size: 18px;
  color: white;
  letter-spacing: 4px;
`;

const SnoozeHeaderSkipButton = styled.Text`
  color: #A6A8AB;
  font-family: 'Montserrat-SB';
  font-size: 12px;
  margin-bottom: 55px;
  letter-spacing: 2px;
`;

const SnoozeHeaderSubText = styled.Text`
  font-family: 'Montserrat-EB';
  font-size: 14px;
  color: white;
`;

const SnoozeCommonButtonParent = styled.View`
  margin-top: 15px;
`;

const SnoozeCommonButton = styled(SnoozeHeaderButton)`
  background: transparent;
  border: 2px solid #B9DAFF;
  width: 300px;
  height: 50px;
  margin-bottom: 20px;
`;

const SnoozeCommonButtonText = styled(SnoozeHeaderButtonText)`

`;

export default Snooze;